import { render } from "./GetStartedCallToAction.vue?vue&type=template&id=0ba4ed44&scoped=true"
import script from "./GetStartedCallToAction.vue?vue&type=script&lang=js"
export * from "./GetStartedCallToAction.vue?vue&type=script&lang=js"

import "./GetStartedCallToAction.vue?vue&type=style&index=0&id=0ba4ed44&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0ba4ed44"

export default script